<template>
    <div>
        <p>
            <span class="has-text-weight-bold">Respuesta: </span
            >{{ answer }}
        </p>
    </div>
</template>

<script>
export default {
    name: "date-action-item",
    props: {
        action: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            answer: "",
        };
    },
    mounted() {
        this.answer = this.action.answer;
    },
    watch: {
        action: {
            deep: true,
            handler(action) {
                this.answer = action.answer;
            },
        },
    },
};
</script>